import {CONGRATS_STEP_ID} from "../../constants";
import _ from "lodash";

export const initServiceNavigateBack = async (currService, lastFinishedStep) => {
  currService.finished = false;
  if(lastFinishedStep){
    await currService.goToStep(lastFinishedStep);
  } else if(currService.step && currService.step.uid === CONGRATS_STEP_ID){
    // as there is no back button in congrats step
    await currService.prevStep();
  }
  // store current step
  await currService.sendCurrentStep(_.get(currService.step, 'uid'));
}